import { useRef, useCallback } from "react";

export default function useDebounce() {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const debounce = (callback: () => void, ms?: number) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      callback();
    }, ms ?? 300);
  };

  return {
    debounce: useCallback(debounce, []),
  };
}
